__turbopack_context__.v({
  "Avatar": "CommentItem-module-scss-module__4AfZOq__Avatar",
  "Fallback": "CommentItem-module-scss-module__4AfZOq__Fallback",
  "Image": "CommentItem-module-scss-module__4AfZOq__Image",
  "autoLink": "CommentItem-module-scss-module__4AfZOq__autoLink",
  "col": "CommentItem-module-scss-module__4AfZOq__col",
  "footer": "CommentItem-module-scss-module__4AfZOq__footer",
  "inline": "CommentItem-module-scss-module__4AfZOq__inline",
  "itemRoot": "CommentItem-module-scss-module__4AfZOq__itemRoot",
  "menuWrapper": "CommentItem-module-scss-module__4AfZOq__menuWrapper",
  "mob": "CommentItem-module-scss-module__4AfZOq__mob",
  "name": "CommentItem-module-scss-module__4AfZOq__name",
  "position": "CommentItem-module-scss-module__4AfZOq__position",
  "postContent": "CommentItem-module-scss-module__4AfZOq__postContent",
  "repliesWrapper": "CommentItem-module-scss-module__4AfZOq__repliesWrapper",
  "reply": "CommentItem-module-scss-module__4AfZOq__reply",
  "replyBtn": "CommentItem-module-scss-module__4AfZOq__replyBtn",
  "sub": "CommentItem-module-scss-module__4AfZOq__sub",
  "subItem": "CommentItem-module-scss-module__4AfZOq__subItem",
  "time": "CommentItem-module-scss-module__4AfZOq__time",
});
